import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Whether the project has real Supabase credentials.
 *
 * When it does not, `main.tsx` renders setup instructions instead of the app.
 * Throwing here would take the whole bundle down with a blank page and a
 * console trace, which is a poor first run for anyone cloning the repo.
 */
export const isSupabaseConfigured = Boolean(url && anonKey);

/**
 * Auth only.
 *
 * This client signs users in and keeps the session fresh; it never reads or
 * writes application tables. Those go through the Node API, which owns
 * authorisation. The database has RLS on with the table grants revoked, so
 * even this key pointed at PostgREST would come back empty.
 */
export const supabase = createClient(
  url || "https://placeholder.supabase.co",
  anonKey || "placeholder-anon-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  },
);
